// removed by extract-text-webpack-plugin
module.exports = {"container":"container___1qcKR","containerStandAlone":"containerStandAlone___1kKbd","attention":"attention___2KVi-"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/Unauthorized/styles.scss
// module id = 470
// module chunks = 0